import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Module } from 'data/terra/Module';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import { CommonState } from '../reducer';

export const FETCH_MODULES = 'FETCH_MODULES';

export interface FetchModulesAction {
  type: typeof FETCH_MODULES;
  modules: Module[];
}

export const fetchModules = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => async dispatch => {
  const result = await Terra.module.fetchModules();
  if (result.isSuccess()) {
    dispatch({
      type: FETCH_MODULES,
      modules: result.get()!.data,
    } as FetchModulesAction);
  }

  return result;
};

export const fetchModulesDelegate: DelegateMapEntry<
  FetchModulesAction,
  CommonState
> = {
  [FETCH_MODULES]: (
    state: CommonState,
    action: FetchModulesAction
  ): CommonState => {
    return {
      ...state,
      modules: action.modules,
    };
  },
};
